export default __webpack_public_path__ + "static/black-213f85f40ed998979f9990a6cb99646a.jpg";